import LazyGruser from './LazyGruserZone';

export default LazyGruser;
